import React from 'react';
import { useTranslation } from 'react-i18next';

/** Seletor PT | EN - usado no login, perfil e builder. Compact = empilhado verticalmente para sidebar estreita */
export default function LanguageSwitcher({ className = '', compact }) {
  const { i18n } = useTranslation();

  return (
    <div className={`flex rounded-lg overflow-hidden ${compact ? 'flex-col w-full gap-0.5' : 'flex-row items-center gap-0.5 border border-slate-200 dark:border-slate-600'} ${className}`}>
      <button
        type="button"
        onClick={() => i18n.changeLanguage('pt')}
        className={`${compact ? 'w-full px-2 py-1.5 text-xs' : 'px-3 py-1.5 text-sm'} font-medium transition-colors ${
          i18n.language === 'pt'
            ? 'bg-blue-600 text-white'
            : 'bg-white dark:bg-slate-800 text-slate-600 dark:text-slate-400 hover:bg-slate-50 dark:hover:bg-slate-700'
        }`}
      >
        PT
      </button>
      <button
        type="button"
        onClick={() => i18n.changeLanguage('en')}
        className={`${compact ? 'w-full px-2 py-1.5 text-xs' : 'px-3 py-1.5 text-sm'} font-medium transition-colors ${
          i18n.language === 'en'
            ? 'bg-blue-600 text-white'
            : 'bg-white dark:bg-slate-800 text-slate-600 dark:text-slate-400 hover:bg-slate-50 dark:hover:bg-slate-700'
        }`}
      >
        EN
      </button>
    </div>
  );
}
